import Icon from "components/common_components/Icon";

export const getLabel = (id) => statuses[id]?.label || id;

const statuses = {
    todo: {
        label: "To Do",
        category: "default",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    open: {
        label: "Open",
        category: "default",
        Icon: <Icon name="high-priority" size="sm" />,
    },
    inprogress: {
        label: "In Progress",
        category: "info",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    closed: {
        label: "Closed",
        category: "success",
        Icon: <Icon name="lock" size="sm" />,
    },
    resolved: {
        label: "Resolved",
        category: "success",
        Icon: <Icon name="lock" size="sm" />,
    },
    completed: {
        label: "Completed",
        category: "success",
        Icon: <Icon name="lock" size="sm" />,
    },
    cancelled: {
        label: "Cancelled",
        category: "error",
        Icon: null,
    },
    rejected: {
        label: "Rejected",
        category: "error",
        Icon: null,
    },
    pending: {
        label: "Pending",
        category: "warning",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    approved: {
        label: "Approved",
        category: "success",
        Icon: null,
    },
    draft: {
        label: "Draft",
        category: "info",
        Icon: <Icon name="time-lapse" size="sm" />,
    },
    new: {
        label: "NEW",
        category: "warning",
    },
    active: {
        label: "Active",
        category: "success",
    },
    oldVersion: {
        label: "Old Version",
        category: "error",
    },
    inactive: {
        label: "Inactive",
        category: "error",
    },
};

export default statuses;
